module.exports = __webpack_public_path__ + "front/img/10_4.39ffa6ac.png";